export const REPLACE_BROKEN_DEVICE_MODAL_SHIPPING_FORM =
  'REPLACE_BROKEN_DEVICE_MODAL_SHIPPING_FORM'
export const REPLACE_BROKEN_DEVICE_MODAL_SUMMARY_FORM =
  'REPLACE_BROKEN_DEVICE_MODAL_SUMMARY_FORM'
